import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { isError, ok } from "@nju/result";
import { IGetSimCardListResult } from "./types";
import { IPukNumber, serverResponse } from "./validators";

interface IGetSimCardListParams {
  simNumber: string | undefined;
  userId: string | undefined;
}

export async function getSimCardList({
  simNumber,
  userId,
}: IGetSimCardListParams): Promise<IGetSimCardListResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/SIM/list`,
    {
      headers: {
        version: "1",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
      searchParams: {
        ...(userId && { userId }),
      },
      validator: serverResponse,
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);
    return result;
  }

  const cardNumber = result.value[0].cardIccid;

  const pukNumber = result.value[0].cardCharacteristics.find((item) => {
    return item.name === "PUK" && cardNumber === simNumber;
  }) as IPukNumber | undefined;

  return ok({
    pukNumber,
  });
}
